import { createSlice } from "@reduxjs/toolkit";
import { getRoleAPI } from "../../api/role";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getRoleSlice = createSlice({
  name: "getRole",
  initialState: data,
  reducers: {
   getRoleSlice(state) {
      state.isLoading = true;
    },
   getRoleSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getRoleSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getRoleSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getRoleHandler = (selectedStatus:any,sortField:any,sortDirection:any) => async (dispatch: any) => {
  try {
    dispatch(getRoleAction.getRoleSlice());
    const response: any = await getRoleAPI(selectedStatus,sortField,sortDirection);
    
    dispatch(getRoleAction.getRoleSliceSuccess(response));
  } catch (e: any) {
    dispatch(getRoleAction.getRoleSliceFailure(e?.response?.data));
  }
};
export default getRoleSlice.reducer;
export const getRoleAction = getRoleSlice.actions;
